import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import Capabilities from "./components/Capabilities";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Journey from "./components/Journey";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function Home() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Capabilities />
      <About />
      <Portfolio />
      <Journey />
      <Testimonials />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
